module.exports = __webpack_public_path__ + "img/integration2.38ae5b61.png";